// マスタseed投入（中身/TMS・開発ユーティリティ）。得意先/傭車先をFirestoreへ一括UPSERT。
// docId = コード(+枝番)。名寄せ済みの正式名称・登録番号(T)を初期データとして入れる。
import { COLLECTIONS, upsert } from '../collections.js'
// seed も static import をやめた（2026-08-24）。得意先の正式名称・CD・登録番号が
// 公開JSバンドルに入ってしまうため。実体は masters/ にあり、認証つき Function から取る。
import { authedJson } from '../../serverData.js'

const idOf = (r) => r.codeStr // 例: "000191-7" / "000004"

export async function seedCustomers() {
  const customers = await authedJson('api/masters/customers')
  let n = 0
  for (const r of customers) {
    await upsert(COLLECTIONS.customers, idOf(r), {
      code: r.code, branchNo: r.branchNo ?? null,
      name: r.formal, formal: r.formal, tnum: r.tnum || '',
      aliases: r.aliases || [], source: 'deneb-master',
    })
    n++
  }
  return n
}

export async function seedPartners() {
  const partners = await authedJson('api/masters/partners')
  let n = 0
  for (const r of partners) {
    await upsert(COLLECTIONS.partners, idOf(r), {
      code: r.code, branchNo: r.branchNo ?? null,
      name: r.formal, formal: r.formal, tnum: r.tnum || '',
      aliases: r.aliases || [], source: 'deneb-master',
    })
    n++
  }
  return n
}

// 得意先128 / 傭車先61（うちT番号13）を投入。開発時に一度だけ実行。
export async function seedMasters() {
  const c = await seedCustomers()
  const p = await seedPartners()
  return { customers: c, partners: p }
}
